export default {
  name: 'landing',
  data: function() {
    return {
      id: '',
      senseID: '',
      linkAddress: 'groheondus://guard/installation/finished/'
    }
  },
  computed: {
    landingText: function() {
      return this.$store.getters.langFile[this.$options.name]
    },
    legal: function() {
      return this.$store.getters.langFile.legal
    }
  },
  methods: {
    routeToPlan: function() {
      let id = this.$route.params.id
      this.$store.commit('changeName', 'entry-component')
      this.$store.commit('changeColor', true)
      this.$router.push({
        name: 'plan',
        params: {
          id
        }
      })
    },
    goToImprint: function() {
      let id = this.$route.params.id
      this.$router.push({
        name: 'imprint',
        params: {
          id
        }
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/landing-interlude/landing-interlude.js